import { BaseDto } from "@/shared/dtos/base-dto";

export class ClassReportWizardForm extends BaseDto {
  public ids_actuacion!: number[];
}
